<template>
    <div class="mt-6 flex items-center justify-between">
        <div class="text-gray-800">
            <div>
                Gift Card &mdash;
                <span class="text-gray-600">{{ giftCard.token }}</span>
            </div>

            <div class="grid grid-cols-2 gap-x-4 pl-2 text-sm text-gray-500">
                <div>Current Balance:</div>
                <div>
                    {{ currentBalance }}
                </div>
                <div>Balance After Payment:</div>
                <div>
                    {{ balanceAfterPayment }}
                </div>
            </div>

            <prime-button
                label="Remove"
                class="ml-2 !p-0"
                link
                size="small"
                severity="danger"
                :disabled="isProcessing"
                @click="$emit('remove')"
            />
        </div>

        <div>
            {{ balanceToUseFormatted }}
        </div>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'
import { computed } from 'vue'
import { Decimal } from '~/composables/support/decimal'
import { useCheckoutFormProcessing } from '~/components/Checkout/Forms/use-checkout-form'

const props = defineProps<{
    giftCard: GiftCardPaymentInfo
}>()

defineEmits<{
    (e: 'remove'): void
}>()

const { isProcessing } = useCheckoutFormProcessing()

const currentBalance = computed(() => {
    return new Decimal(props.giftCard.currentBalance).formatCurrency()
})

const balanceAfterPayment = computed(() => {
    return new Decimal(props.giftCard.currentBalance)
        .minus(new Decimal(props.giftCard.amount))
        .formatCurrency()
})

const balanceToUseFormatted = computed(() => {
    return new Decimal(props.giftCard.amount)
        .invertSign()
        .formatCurrency(2, false)
})
</script>
